import { Outlet } from "react-router-dom";

function LobbyLayout() {
    return <Outlet />;
}

export default LobbyLayout;
